import { useEffect, useState } from 'react';

export function useCheckingToken(token, method, { onError } = {}) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        setIsLoading(true);
        const data = await method(token);
        setData(data);
        setIsLoading(false);
      } catch (err) {
        if (onError) onError(err);

        setError(err);
        setIsLoading(false);
        throw err;
      }
    };

    run();
  }, [method, token]);

  return { isLoading, data, error };
}
